/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// import Flags from '../../components/Flags';
import User from './components/User';
import Notifications from './components/Notifications';
import SocialMedia from '../../components/icons/SocialMedia';
import Prices from './components/Prices';
import Logo from '../../assets/images/static/Logo.svg';

import color from '../../assets/scss/variables/colors.module.scss';

const Header = ({ language }) => {
  const { t } = useTranslation();
  const { colorSecundario } = color;

  return (
    <>
      <header className='header'>
        {/** Header content */}
        <div className='header__content'>
          {/** Header logo */}
          <Link to={`${t('routes.home')}`} className='header__content__logo'>
            <img loading='auto' src={Logo} alt='Tower Partners' />
          </Link>
          {/** Header logo */}

          {/** Header links */}
          <div className='header__content__links'>
            {/* Header Prices text */}
            <Prices />
            {/* Header Prices text */}

            {/* Header user Actions */}
            <div className='header__content__links__actions'>
              {/* Help Icon */}
              <Link to=''>{/* <HelpIcon /> */}</Link>

              {/* User Icon */}
              <User />

              {/* Notifications Icon */}
              {/* <Notifications /> */}
            </div>
            {/* Header user Actions */}

            {/** Header lang buttons */}
            <div className='header__content__links__languages'>
              {/* <Flags /> */}
              <SocialMedia fill={colorSecundario} background='transparent' />
            </div>
            {/** Header  lang buttons */}
          </div>
          {/** Header links */}
        </div>
        {/** Header content */}
      </header>
    </>
  );
};

export default Header;
